import { Event, EventType, EventsState } from './events.types';

export const groupEventsByType = (data: EventsState['data']) =>
  Object.values(data).reduce<Record<EventType, Event[]>>(
    (accumulator, event) => {
      accumulator[event.type].push(event);

      return accumulator;
    },
    {
      Onboarding: [],
      StatusChange: [],
    },
  );
